import { TextField, TextFieldProps } from '@mui/material';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';

type FormTextFieldProps<T extends FieldValues, TTransformedValues = T> = TextFieldProps & {
  name: Path<T>;
  control: Control<T, unknown, TTransformedValues>;
};

const FormTextField = <T extends FieldValues, TTransformedValues = T>({
  name,
  control,
  ...textFieldProps
}: FormTextFieldProps<T, TTransformedValues>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <TextField
          {...field}
          value={field.value ?? ''}
          onChange={(e) => {
            const value = textFieldProps.type === 'number' && e.target.value ? Number(e.target.value) : e.target.value;
            field.onChange(value);
          }}
          select={textFieldProps.type === 'select'}
          {...textFieldProps}
        >
          {textFieldProps.type === 'select' && textFieldProps.children}
        </TextField>
      )}
    />
  );
};

export default FormTextField;
